export const NOT_ENTERED = 'Not Entered';
export const EMPTY_SYMBOL = '—';
